import { getDefaultFilter } from './default-filter';

export function getCorrectPeriod(period: any) {
  const defaultValue = getDefaultFilter();
  return period &&
    typeof period.startDate === 'string' &&
    typeof period.endDate === 'string'
    ? {
        startDate: period.startDate,
        endDate: period.endDate,
      }
    : defaultValue.period;
}
